import { useNuxtApp } from '#app'

export function useLocalize() {
  const { $localize } = useNuxtApp()

  const translate = (text: string) => {
    if (!$localize) {
      console.warn('Localize is not available')
      return text
    }
    return $localize.translate(text)
  }

  const setLanguage = (languageCode: string) => {
    if (!$localize) {
      console.warn('Localize is not available')
      return setLanguage
    }
    return $localize.setLanguage(languageCode)
  }

  const getLanguage = () => {
    if (!$localize) {
      console.warn('Localize is not available')
      return
    }
    return $localize.getLanguage()
  }

  return {
    translate,
    getLanguage,
    setLanguage,
  }
}
